import React from "react";
import { useSelector } from "react-redux";
import { IntlProvider } from "react-intl";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Box, Container } from "@mui/material";
import translations from "app/libs/i18n/translations.json";
import MainAppBar from "bundles/Layouts/MainAppBar";
import Login from "bundles/Devise/Login/components/Login";
import ForgottenPassword from "bundles/Devise/Password/components/ForgottenPassword";
import ChangePassword from "bundles/common/components/ChangePassword";
import ResendConfirmation from "bundles/common/components/ResendConfirmation";

const LoginContainer = () => {
  const i18nLocale = useSelector((state) => state.i18nLocale);
  const locale = i18nLocale;
  const messages =
    translations[locale] || (locale === "fr-fr" ? translations.fr : {});

  return (
    <IntlProvider locale={locale} key={locale} messages={messages}>
      <BrowserRouter>
        <Routes>
          <Route
            path={`/${i18nLocale}/candidates/sign_in`}
            element={<Login defaultUserType="candidate" />}
          />

          {/* Utility auth pages */}
          <Route
            path={`/${i18nLocale}/candidates/password/new`}
            element={
              <Box>
                <MainAppBar />
                <Container maxWidth="sm" sx={{ mt: 8 }}>
                  <ForgottenPassword userType="candidates" />
                </Container>
              </Box>
            }
          />
          <Route
            path={`/${i18nLocale}/candidates/password/edit`}
            element={
              <Box>
                <MainAppBar />
                <Container maxWidth="sm" sx={{ mt: 8 }}>
                  <ChangePassword userType="candidates" />
                </Container>
              </Box>
            }
          />
          <Route
            path={`/${i18nLocale}/candidates/confirmation/new`}
            element={
              <Box>
                <MainAppBar />
                <Container maxWidth="sm" sx={{ mt: 8 }}>
                  <ResendConfirmation userType="candidates" />
                </Container>
              </Box>
            }
          />

          <Route
            path={`/${i18nLocale}`}
            element={<Navigate to={`/${i18nLocale}/candidates/sign_in`} />}
          />
        </Routes>
      </BrowserRouter>
    </IntlProvider>
  );
};

export default LoginContainer;
